import React from 'react';
import { Spinner as ChakraSpinner, SpinnerProps, useColorModeValue } from '@chakra-ui/react';

export const Spinner = (props: SpinnerProps) => {
	const color = useColorModeValue('brand.primary', 'brand.primary');
	return <ChakraSpinner thickness="4px" speed="0.65s" color={color} size="xl" {...props} />;
};
